module.exports = __webpack_public_path__ + "img/spotify-playlists-analysis.98cf6f94.jpg";